<template>
    <div class="MT45Page">
        <link rel="preconnect" href="https://fonts.googleapis.com">
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
        <page-navigate></page-navigate>
         <div class="MT5Header flex box-border">
      <div class="MT5HeaderMain">
        <h1 class="MT5Title super_large-80_bold md-title-32_bold">
          MetaTrader 5
        </h1>
        <h2 class="MT5Desc subtitle-20_regular md-body-14_regular">
          MT5是新一代多资产交易平台，集成了更先进的交易功能和分析工具，满足全球交易者的多样化需求
        </h2>
        <a :href="signupUrl" class="jumpA">
          <div class="MT5Btn primary-default_large cursor-pointer">
            开始交易
            <span class="iconfont icon-right"></span>
          </div>
        </a>
      </div>
      <img
        src="@/assets/image/mt/mt5Container1.png"
        alt=""
        class="MT5HeaderModel"
      />
    </div>
    <div class="MT5Download">
      <div class="contentBox">
       
        <h2 class="title-48_bold md-title-24_bold MT5DownloadTitle text-center scroll-fade-up">
          MetaTrader 5 下载
        </h2>
        <h3 class="MT5DownloadDesc subtitle-20_regular md-footnote-regular_12 text-center scroll-fade-up">连接全球多元化资产，先进市场深度和灵活交易系统，随时掌控市场机遇</h3>

        <!-- <h3
          class="subtitle-20_regular md-footnote-regular_12 MT5DownloadDesc text-center scroll-fade-up"
        >
          选择您偏好的设备，下载适用的 MT5
          平台程序，立即体验高速顺畅，且符合个人风格的交易
        </h3> -->
        <div class="MT5DownloadList flex justify-center scroll-fade-up">
          <div class="MT5DownloadListCard">
            <div class="title-24_bold subtitle-20_medium MT5DownloadCardTitle text-center">MT5 移动端</div>
          <div class="MT4DownloadCardDesc body-14_regular  md-footnote-regular_12">
              随时随地进行交易，掌握市场动态，轻松管理账户
            </div>
          <a href="https://edocs-1305385874.cos.ap-hongkong.myqcloud.com/web/metatrader5.apk" class="MT5ATag" target="_blank">
            <!-- <img src="@/assets/image/mt/QRCodeLogo.png" alt="" class="qrCode pc"> -->
            <div class="MT5DownloadItem">
              <img src="@/assets/image/mt/android.png" alt="">
              <div class="subtitle-20_medium">下载安卓版</div>

            </div>
            <div class="hoverDownloadItem">
              <img src="@/assets/image/mt/clickToDownload.svg" alt="">
              <div class="title-24_medium">点击下载</div>
            </div>
          </a>
          <a href="https://apps.apple.com/cn/app/metatrader-5/id413251709 " class="MT5ATag" target="_blank">
            <!-- <img src="@/assets/image/mt/QRCodeLogo.png" alt="" class="qrCode pc"> -->
            <div class="MT5DownloadItem">
              <img src="@/assets/image/mt/ios.svg" alt="">
              <div class="subtitle-20_medium">下载苹果版</div>

            </div>
            <div class="hoverDownloadItem">
              <img src="@/assets/image/mt/clickToDownload.svg" alt="">
              <div class="title-24_medium">点击下载</div>
            </div>
          </a>
          
          </div>
          <div class="MT5DownloadListCard">
            <div class="title-24_bold subtitle-20_medium MT5DownloadCardTitle text-center">MT5 电脑端</div>
<div class="MT4DownloadCardDesc body-14_regular  md-footnote-regular_12">
              全面的交易工具和高级图表分析，满足专业交易者的高阶需求
            </div>
          <a href="https://edocs-1305385874.cos.ap-hongkong.myqcloud.com/web/ebcfinancialgroupky5setup.exe" class="MT5ATag" target="_blank">
            <div class="MT5DownloadItem">
              <img src="@/assets/image/mt/windows.svg" alt="">
              <div class="subtitle-20_medium">下载Windows版</div>
            </div>
            <div class="hoverDownloadItem">
              <img src="@/assets/image/mt/clickToDownload.svg" alt="">
              <div class="title-24_medium">点击下载</div>
            </div>
          </a>
          <a href="https://edocs-1305385874.cos.ap-hongkong.myqcloud.com/web/MetaTrader5.pkg.zip" class="MT5ATag" target="_blank">
            <div class="MT5DownloadItem">
              <img src="@/assets/image/mt/macos.svg" alt="">
              <div class="subtitle-20_medium">下载MacOS版</div>

            </div>
            <div class="hoverDownloadItem">
              <img src="@/assets/image/mt/clickToDownload.svg" alt="">
              <div class="title-24_medium">点击下载</div>
            </div>
          </a>
          </div>
          <div class="MT5DownloadListCard">
            <div class="title-24_bold subtitle-20_medium MT5DownloadCardTitle text-center">MT5 网页版</div>
            <div class="MT4DownloadCardDesc body-14_regular md-footnote-regular_12 zh">
              无需下载，极速访问全球市场，轻松实现全方位的在线交易管理
            </div>
          <a href="https://ebcfinweb.com/metatrader5/?lang=zh" class="MT5ATag" target="_blank">
            <div class="MT5DownloadItem">
              <img src="@/assets/image/mt/pc.png" alt="">
              <div class="subtitle-20_medium">打开网页版</div>

            </div>
            <div class="hoverDownloadItem">
              <img src="@/assets/image/mt/clickToDownload.svg" alt="">
              <div class="title-24_medium">点击下载</div>
            </div>
          </a>
          </div>
          

        </div>
      </div>
    </div>
   
    <div class="MT45Diff ">
      <div class="contentBox">
      <h2 class="title-48_bold md-title-24_bold text-center scroll-fade-up">MT4 与 MT5 的区别</h2>
      <h3 class="MT45DiffDesc subtitle-20_regular md-footnote-regular_12 text-center scroll-fade-up">MT4 和 MT5 均由 MetaQuotes 开发，但 MT5 并非 MT4 的简单升级版，两者在功能和适用范围上存在显著差异</h3>
      <div class="MT45DiffTable scroll-fade-up">
        <div class="MT45Thead">
          <div class="body-16_medium md-body-14_medium">账户平台</div>
          <div class="subtitle-18_medium md-body-14_medium">MT4</div>
          <div class="subtitle-18_medium md-body-14_medium">MT5</div>
        </div>
        <div class="MT45Tbody">
          <div class="MT45Tr">
            <div class="MT45Td body-16_regular md-footnote-regular_12">发布时间</div>
            <div class="MT45Td title-24_bold md-subtitle-18_medium">2005 <span class="body-16_medium  md-footnote-medium_12">年</span> </div>
             <div class="MT45Td title-24_bold md-subtitle-18_medium">2010 <span class="body-16_medium  md-footnote-medium_12">年</span> </div>
          </div>
          <div class="MT45Tr">
            <div class="MT45Td body-16_regular md-footnote-regular_12">交易市场</div>
            <div class="MT45Td body-16_medium md-footnote-medium_12">主要是外汇</div>
             <div class="MT45Td body-16_medium md-footnote-medium_12">包括股票、期货、外汇等</div>
          </div>
          <div class="MT45Tr">
            <div class="MT45Td body-16_regular md-footnote-regular_12">挂单类型</div>
            <div class="MT45Td title-24_bold md-subtitle-18_medium">4 <span class="body-16_medium  md-footnote-medium_12">种</span></div>
             <div class="MT45Td title-24_bold md-subtitle-18_medium">6 <span class="body-16_medium  md-footnote-medium_12">种</span></div>
          </div>
          <div class="MT45Tr">
            <div class="MT45Td body-16_regular md-footnote-regular_12">时间框架</div>
            <div class="MT45Td title-24_bold md-subtitle-18_medium">9 <span class="body-16_medium md-footnote-medium_12">种</span></div>
             <div class="MT45Td title-24_bold md-subtitle-18_medium">21 <span class="body-16_medium md-footnote-medium_12">种</span></div>
          </div>
          <div class="MT45Tr">
            <div class="MT45Td body-16_regular md-footnote-regular_12">技术指标</div>
            <div class="MT45Td title-24_bold md-subtitle-18_medium">30 <span class="body-16_medium md-footnote-medium_12">个</span></div>
             <div class="MT45Td title-24_bold md-subtitle-18_medium">38 <span class="body-16_medium md-footnote-medium_12">个</span></div>
          </div>
          <div class="MT45Tr">
            <div class="MT45Td body-16_regular md-footnote-regular_12">市场深度</div>
            <div class="MT45Td title-24_bold"><img src="@/assets/image/mt/mtTableF.svg" alt=""></div>
             <div class="MT45Td title-24_bold"><img src="@/assets/image/mt/mtTableY.svg" alt=""></div>
          </div>
          <div class="MT45Tr">
            <div class="MT45Td body-16_regular md-footnote-regular_12">财经日历</div>
            <div class="MT45Td title-24_bold"><img src="@/assets/image/mt/mtTableF.svg" alt=""></div>
             <div class="MT45Td title-24_bold"><img src="@/assets/image/mt/mtTableY.svg" alt=""></div>
          </div>
          <div class="MT45Tr">
            <div class="MT45Td body-16_regular md-footnote-regular_12">操作界面</div>
            <div class="MT45Td body-16_medium md-footnote-medium_12">更直观简单</div>
             <div class="MT45Td body-16_medium md-footnote-medium_12">更加现代化灵活</div>
          </div>
        </div>
      </div>
      </div>
    </div>
    <open-account-mt45></open-account-mt45>
    <section class="container4 commonQuestion">
      <div class="contentBox">
        <h2 class="scroll-fade-up">MT5常见问题</h2>
        <div class="QA-list">
          <div class="QA-item">
            <div class="QA-title">1、什么是MetaTrader5（MT5）？它与MT4有何不同？</div>
            <div class="QA-content">
              <p class="QA-li">MT5是新一代多资产交易平台，支持外汇、商品、指数、股票。与MT4相比，它提供更多时间框架、额外订单类型、内置经济日历和更快处理速度。通过EBC连接时，MT5可实现更高性能、更广泛的市场接入和更深度的分析能力。</p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title">2、为何交易者选择MT5进行外汇和多资产交易？</div>
            <div class="QA-content">
              <p class="QA-li">交易者青睐MT5的多样性和速度优势。平台支持多资产类别交易，配备深度市场分析、集成分析工具和强大的订单管理功能。EBC通过低延迟执行和机构级流动性增强体验，帮助交易者精准把握机会。</p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title">3、MT5是否适合新手和专业交易者？</div>
            <div class="QA-content">
              <p class="QA-li">适合。MT5为适合不同阶段的交易者进行了针对性设计：新手交易者受益于其简洁界面和易用导航，专业人士则重视高级图表工具、算法交易支持和更快订单执行。通过EBC，MT5成为学习、交易和策略扩展的高效环境。</p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title">4、MT5可交易哪些资产类别？</div>
            <div class="QA-content">
              <p class="QA-li">通过EBC的MT5接入，可交易货币对、全球指数、商品、股票CFDs、ETF等。多市场接入能力，支持单一账户管理不同策略、分散风险并捕捉全球市场24小时交易机会。</p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title">5、MT5是否比MT4提供更快执行和更先进工具？</div>
            <div class="QA-content">
              <p class="QA-li">是的。MT5采用64位多线程架构，实现更快交易执行和实时数据处理。新增图表功能、技术指标和内置策略测试器。搭配EBC的稳健硬件架构，提供卓越执行速度和分析精度。</p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title">6、下载和使用MT5需要费用吗？</div>
            <div class="QA-content">
              <p class="QA-li">MetaTrader5完全免费下载使用。EBC客户可免费在桌面或移动端安装，无订阅费或设置费。仅需支付标准交易成本（如点差或佣金），EBC账户全程透明展示。</p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title">7、通过EBC使用MT5平台的安全性如何？</div>
            <div class="QA-content">
              <p class="QA-li">通过EBC的MT5进行交易，将受到高级加密技术、安全数据传输和严格监管的保护。EBC将客户资金独立存放在隔离银行账户，确保透明度和资金保护。这些措施为交易者提供安全、合规、可信的交易环境。</p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title">8、MT5是否支持自动化交易和专家顾问（EA）？</div>
            <div class="QA-content">
              <p class="QA-li">支持。MT5通过MQL5语言支持全自动化交易，基于实时的市场数据可开发、测试和优化策略。EBC稳定的服务器和快速订单执行，确保自动化交易流畅可靠，适合短线及算法交易者。</p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title">9、MT5提供哪些图表、指标和分析工具？</div>
            <div class="QA-content">
              <p class="QA-li">MT5提供21个时间框架、38个内置指标和超40种分析工具。交易者可自定义图表、叠加多种指标并同步分析多重资产。结合EBC的精准报价和数据流，形成专业级技术分析工具包。</p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title">10、能否通过MT5直接出金？</div>
            <div class="QA-content">
              <p class="QA-li">出入金需要通过EBC客户端安全完成，无法直接在MT5内操作。交易后，MT5账户余额实时更新。通过加密通道，EBC确保出入金快速、安全、合规。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
        <page-footer></page-footer>
    </div>
</template>
<script>
import fadeAnimate from "../mixins/fadeAnimate.js";
import { mapGetters } from 'vuex';

export default {
    mixins: [fadeAnimate],
    data() {
        return {

        }
    },
    mounted() {
      
      document.querySelectorAll('.MT5DownloadItem').forEach((i,index)=>{
        if(index == 4){
          i.insertAdjacentHTML('beforeend',`
          <span class="arrowBtn">
<svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_5783_6509)">
<path d="M23.6666 19.3333C23.6666 19.8855 23.2189 20.3333 22.6666 20.3333C22.1143 20.3333 21.6666 19.8855 21.6666 19.3333V11.7473L7.37361 26.0403C6.98309 26.4308 6.35007 26.4308 5.95955 26.0403C5.56903 25.6498 5.56903 25.0167 5.95955 24.6262L20.2525 10.3333H12.6666C12.1143 10.3333 11.6666 9.88554 11.6666 9.33325C11.6666 8.78097 12.1143 8.33325 12.6666 8.33325H22.6666C23.2189 8.33325 23.6666 8.78097 23.6666 9.33325V19.3333Z" fill="black" fill-opacity="0.64"/>
</g>
<defs>
<clipPath id="clip0_5783_6509">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>
</span>
`)
return
        }
        i.insertAdjacentHTML('beforeend',`<span class="Btn">
  <svg
    class="svgIcon"
    viewBox="0 0 384 512"
    height="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    ></path>
  </svg>
  <span class="icon2"></span>
</span>`)
      })
    },
    computed: {

        ...mapGetters([
            'signupUrl',
        ])
    },
}
</script>
<style scoped>
  .contentBox {
  max-width: 1200rem;
  margin-inline: auto;
}
.MT5Header {
  padding-top: 144rem;
  background-color: var(--ebc-neutral-bg_c);
}

.MT5Header {
  height: 560rem;
  padding-left: calc(50vw - 600rem);
  gap: 62rem;
}
.MT5HeaderMain {
  flex: 0 0 588rem;
  margin-top: 16rem;
}
.MT5Title {
}
.MT5Btn {
  width: fit-content;
  min-width: 180rem;
  gap: 4rem;
}
.jumpA {
  display: block;
  width: fit-content;
}
.MT5Desc {
  color: var(--ebc-text-secondary);
  margin: 24rem 0 64rem;
}

.MT5HeaderModel {
  width: 550rem;
  height: 335rem;
}
.MT5DownloadDesc{
  margin: 16rem 0 60rem;
}
@media screen and (max-width: 996px) {
.MT5DownloadDesc{
margin-bottom: 80rem;
}
  .MT5Header {
    flex-direction: column;
    height: auto;
    gap: 134rem;
    padding: 134rem 32rem 80rem;
    text-align: center;
  }
  .MT5HeaderMain {
    order: 2;
    flex: 1;
  }
  .MT5HeaderModel {
    width: 100%;
    height: 416rem;
  }
  .jumpA {
    width: 100%;
  }
  .MT5Btn {
    width: 100%;
    height: 96rem;
    gap: 8rem;
  }
}

.MT5Download {
  padding: 80rem 0 0;
  background: var(--ebc-basecolor-white-100);
}

.MT5DownloadCardList {
  align-items: stretch;
  gap: 24rem;
  margin-bottom: 120rem;
}
.MT5DownloadCard {
  border-radius: var(--ebc-corner-radius-rc16);
  background: var(--ebc-neutral-bg_b);
  padding: 32rem 24rem;
  flex: 1;
}

.MT5DownloadCard img {
  width: 32rem;
  margin-bottom: 16rem;
}
.MT5DownloadTitle{
  margin-bottom: 0rem;
}
.MT5DownloadDesc {
  margin: 16rem 0 60rem;
  color: var(--ebc-text-secondary);
}
.MT5DownloadList {
   gap: 24rem;
  margin-inline: auto;
  align-items: stretch;
}
.MT5DownloadListCard{
  padding:24rem;
  flex:1;
  border-radius: var(--ebc-corner-radius-rc16);
  border: 1px solid  rgba(0, 0, 0, 0.12);
}
.MT5DownloadListCard a{
  display: block;
}
.MT5DownloadListCard a:nth-child(2){
  margin-top: 24rem;
}
.MT5DownloadListCard a:nth-child(n+3){
  margin-top: 16rem;
}
.MT5ATag {
  border-radius: var(--ebc-corner-radius-rc16);
  flex: 0 0 336em;
  height: 64rem;
  position: relative;
  overflow: hidden;
}


.MT5ATag .MT5DownloadItem {
  padding: 16rem 24rem;
  height: 64rem;
  display: flex;
  align-items: center;
  border-radius: var(--ebc-corner-radius-rc08);
  background: var(--ebc-neutral-bg_b);
}

.MT5ATag .hoverDownloadItem{
  display: none!important;
  position: absolute;
  inset: 0;
  z-index:-1;
  width: 100%;
  height: 100%;
  padding:40rem 0 24rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  color: #000;
}
.MT5ATag .hoverDownloadItem div{
  text-align: center;
}

@media screen and (min-width:996px) {
  .MT5ATag .MT5DownloadItem div{
  font-size: 16rem;
  font-weight: 400;
}


.MT5ATag:hover .MT5DownloadItem div{
  color:var(--ebc-basecolor-active-500);
  font-weight: 500;
}


}
.MT5ATag .hoverDownloadItem img{
  width: 64rem;
  height: 64rem;
}
.MT5ATag img {
  height: 32rem;
  margin-right: 16rem;
}

.MT5ATag .MT5DownloadItem div {
  color: #000;
   margin-right: auto;
  line-height: normal;
}
@media screen and (max-width: 996px) {
  .MT5ATag .MT5DownloadItem div{
  font-size: 28rem;
  font-weight: 400;
}
.MT5ATag .hoverDownloadItem{
  display: none;
}
.MT5ATag .MT5DownloadItem {
  justify-content: flex-end;
}
  .MT5Download {
    padding: 80rem 32rem 0rem;
  }
  .MT5DownloadCardList {
    flex-direction: column;
    gap: 32rem;
    margin-bottom: 160rem;
  }
  .MT5DownloadCard {
    padding: 32rem;
  }
  .MT5DownloadCard img {
    width: 64rem;
    margin-bottom: 32rem;
  }
  .MT5DownloadTitle{
  margin-bottom: 0rem;
}
  .MT5DownloadDesc {
    margin: 16rem 0 80rem;
  }
  .MT5DownloadList {
    gap: 48rem;
    flex-direction: column;
  }
  .MT5DownloadListCard{
    padding:16rem;
    border: 0;
  }
    .MT5DownloadListCard{
    padding:16rem;
    border: 0;
  }
  .MT5DownloadListCard a:nth-child(2){
  margin-top: 48rem;
}
.MT5DownloadListCard a:nth-child(n+3){
  margin-top: 32rem;
}
  .MT5ATag {
    height: 112rem;
    border-radius: var(--ebc-corner-radius-rc16);
  }
  .MT5ATag .MT5DownloadItem {
    padding: 32rem 48rem;
    height: 112rem;
  }
  .MT5ATag:nth-child(3) {
    /* order: 2; */
  }
  .MT5ATag:nth-child(1),
  .MT5ATag:nth-child(2) {
    order: 3;
  }
  .MT5ATag img {
   height: 64rem;
    margin-right: 32rem;
  }


  /* .MT5ATag .MT5DownloadItem div {
    margin-top: 32rem;
    min-height: 48rem;
  } */
}

.MT45Diff {
  padding: 120rem 0;
  background: #fff;
}

.MT45DiffDesc {
  margin: 16rem 0 60rem;
  color: var(--ebc-text-secondary);
}
.MT45DiffTable {
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: var(--ebc-corner-radius-rc16);
}
.MT45Thead {
  display: flex;
  align-items: center;
  background: var(--ebc-neutral-bg_c);
  padding: 25rem 40rem;
}
.MT45Tbody {
  padding-inline: 40rem;
}
.MT45Thead div:first-child {
  flex: 1;
  text-align: left;
}
.MT45Tr div:first-child {
  color: var(--ebc-text-tertiary);
  text-align: left;
  flex: 1;
}
.MT45Thead div,
.MT45Tr div {
  text-align: center;
}
.MT45Tr {
  display: flex;
  align-items: center;
}
.MT45Thead div:nth-child(2),
.MT45Tr div:nth-child(2) {
  flex: 3;
}

.MT45Thead div:nth-child(3),
.MT45Tr div:nth-child(3) {
  flex: 1.8;
}
.MT45Tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding: 16rem 0;
}
.MT45Tr .MT45Td {
  min-height: 36rem;
  line-height: 36rem;
}

.MT45Tr:last-child {
  border: 0;
}
.MT4DownloadCardDesc{
  margin:8rem 0 32rem;
  min-height: 44rem;
  color: var(--ebc-text-secondary);
}
@media screen and (min-width: 996px) {
  .MT45Tbody img{
    transform: translateY(4rem);
  }
}
@media screen and (max-width: 996px) {
   .MT5DownloadItem svg{
    width: 24px;
    height: 24px;
  }
.MT4DownloadCardDesc{
margin: 16rem 0 32rem;
text-align: center;

}

  .MT45Diff {
    padding: 160rem 32rem;
  }
  .MT45DiffDesc {
    margin: 16rem 0 80rem;
  }
  .MT45Tr div,
  .MT45Thead div {
    min-height: 112rem;
    padding: 16rem 24rem;
  }
  .MT45Thead div:nth-child(2),
  .MT45Tr div:nth-child(2),
  .MT45Thead div:nth-child(3),
  .MT45Tr div:nth-child(3) {
    flex: 1.6;
  }
  .MT45Thead,
  .MT45Tbody {
    padding: 0;
  }
  .MT45Thead div,
  .MT45Tr div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4rem;
  }
   .MT45Thead div:nth-child(1),
  .MT45Tr div:nth-child(1){
    justify-content: flex-start;
  }
   .ar .MT45Thead div:nth-child(1),
  .ar .MT45Tr div:nth-child(1){
    justify-content: flex-end;
    text-align: right;
  }
  .MT45Td span {
    align-self: flex-end;
    line-height: 30rem;
  }
}




</style>
<style lang="scss">
@import url("../assets/css/commonQuestion.scss");

.MT5ATag:hover .MT5DownloadItem svg path{
  fill: #fff;
  fill-opacity: 1;
}

.MT45Page {
  .Btn {
  width: 32rem;
  height: 32rem;
  border: none;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition-duration: 0.3s;
}

.svgIcon {
  fill: var(--ebc-text-secondary);
  width: 10px;
  height: 18px;
}

.icon2 {
  width: 16px;
  height: 4px;
  border-bottom: 2px solid var(--ebc-text-secondary);
  border-left: 2px solid var(--ebc-text-secondary);
  border-right: 2px solid var(--ebc-text-secondary);
  margin-top: -4px;
}




.attchDownload:hover .icon2,
.MT5DownloadItem:hover .icon2 {
  border-bottom: 2px solid var(--ebc-basecolor-active-500);
  border-left: 2px solid var(--ebc-basecolor-active-500);
  border-right: 2px solid var(--ebc-basecolor-active-500);
}
.attchDownload:hover .svgIcon,
.MT5DownloadItem:hover .svgIcon {
  fill: var(--ebc-basecolor-active-500);
  animation: slide-in-top 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@keyframes slide-in-top {
  0% {
    transform: translateY(-10px);
    opacity: 0;
  }

  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}
@keyframes slide-in-leftBottom {
  0% {
    transform: translate(-50%,50%);
    opacity: 0;
  }

  100% {
    transform: translate(0,0);
    opacity: 1;
  }
}
.MT5ATag .MT5DownloadItem .arrowBtn{
  width: 25rem;
  height: 25rem;
  display: block;
}

.MT5ATag .MT5DownloadItem:hover .arrowBtn svg path{
  fill: var(--ebc-basecolor-active-500);
}
.MT5ATag .MT5DownloadItem:hover .arrowBtn svg {
  animation: slide-in-leftBottom 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

.MT5ATag .MT5DownloadItem:hover .arrowBtn svg:nth-child(2){
  transition: transform 0.3s ease-in-out 0.1s;
  transform: translate(0);
}
.MT5ATag .MT5DownloadItem:hover div{
  color: var(--ebc-basecolor-active-500);
}
.MT5DownloadListCard:first-child .MT5ATag:first-child .MT5DownloadItem:hover div{
  color: var(--ebc-text-primary);
}
.MT5DownloadItem:hover svg path{
  fill: var(--ebc-basecolor-active-500);
}
.MT5DownloadListCard:first-child .downArrow{
  width: 32rem;
  height: 12rem;
}

.attchDownloadList .attchDownload:hover div{
  color: var(--ebc-basecolor-active-500);
}
}
@media (max-width:996px){

}
</style>